import posthog from 'posthog-js'
import { useCallback } from 'react'
import { type ToggleFavoritePlotActionData } from '#app/routes/resources+/plot.toggle-favorite'
import { useStoreContext } from '#app/store'
import { useFetcherWithPromise } from './use-fetcher-with-promise'

export const useToggleFavoritePlot = () => {
	const addFavoritePlotId = useStoreContext(s => s.addFavoritePlotId)
	const removeFavoritePlotId = useStoreContext(s => s.removeFavoritePlotId)

	const fetcher = useFetcherWithPromise<ToggleFavoritePlotActionData>()

	const toggleFavoritePlot = useCallback(
		async (plotId: string) => {
			const formData = new FormData()
			formData.append('plotId', JSON.stringify(plotId))

			const res = await fetcher.submit(formData, {
				method: 'POST',
				action: '/resources/plot/toggle-favorite',
			})

			const isFavorite = res?.isFavorite

			if (isFavorite) {
				addFavoritePlotId(plotId)
				posthog.capture('plot_add_favorite', { plotId })
			} else {
				removeFavoritePlotId(plotId)
				posthog.capture('plot_remove_favorite', { plotId })
			}

			return isFavorite
		},
		[fetcher, removeFavoritePlotId, addFavoritePlotId],
	)

	return toggleFavoritePlot
}
